import React from 'react';
import styled from 'styled-components';
import {TaskSetRow} from './TaskSetListPane';
import {taskSetColour} from './taskSetColours';
import {TaskSetRepeatIcon} from './TaskSetRepeatIcon';

/**
 * Carries the set's colour, the same one its instances' chips carry. min-width: 0
 * lets the chip itself shrink inside the drawer header's title row; the name
 * truncates in its own span below rather than here, so the icon never does.
 */
const NameChip = styled.span<{background: string; foreground: string}>`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	height: 19px;
	padding: 0 8px 0 6px;
	border-radius: 9.5px;
	background: ${({background}) => background};
	color: ${({foreground}) => foreground};
	font-size: 11px;
	font-weight: 600;
	min-width: 0;
`;

/** Truncated with the full name on hover -- a long set name must not push the
    chip past the header and crowd the close button. */
const NameChipText = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	min-width: 0;
`;

export interface TaskSetNameChipProps {
	readonly set: TaskSetRow;
}

/**
 * The set's coloured name chip, rendered by the drawer as its title adornment
 * rather than by the pane below it, so the header owns its own layout.
 */
export const TaskSetNameChip = ({set}: TaskSetNameChipProps) => {
	const colour = taskSetColour(set.id);

	return (
		<NameChip background={colour.background} foreground={colour.foreground} data-cy="task-set-config-name">
			<TaskSetRepeatIcon />
			<NameChipText title={set.name ?? undefined}>{set.name}</NameChipText>
		</NameChip>
	);
};
